import { render, staticRenderFns } from "./ActualizarPaciente.vue?vue&type=template&id=dbeb805a"
import script from "./ActualizarPaciente.vue?vue&type=script&lang=js"
export * from "./ActualizarPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports